<template>
  <div class="mainContent" :style="{ '--scale-factor': scaleFactor }">
    <Header/>
    <!-- 轮播图 -->
    <el-carousel height="460px">
      <el-carousel-item
        v-for="(item, index) in slideShowList"
        :key="index"
        style="height: 460px;"
      >
        <img
          @click="toDetail1(item.id,item)"
          :src="item.coverPic"
          style="height: 100%;width: 100%;cursor: pointer"
        />
      </el-carousel-item>
    </el-carousel>
    <div class="centerDiv">
      <img :src="require('../assets/bg1s.png')" alt="" width="100%" style="position: absolute;top: -45px;z-index: -99;height: 1335px">
      <img :src="require('../assets/bg2s.png')" alt="" width="100%" style="position: absolute;top: 1290px;z-index: -99;object-fit:cover;height: 989px">
      <img :src="require('../assets/bg3s.png')" alt="" width="100%" style="position: absolute;top: 2279px;z-index: -99;object-fit:cover;height: 921px">
      <div class="oneToThree">
        <div class="oneTitleDiv">
          <div class="oneTitle">
            <div class="pubTitle">
              <img :src="require('../assets/title1.png')" alt="" width="28px" height="28px"/>
              <span style="margin-left: 14px;">最新动态</span>
            </div>
            <div class="pubTitles">
              <div style="width: 32px;height: 2px;background: #176DAA;margin-right: 10px"></div>
               News
            </div>
          </div>
          <div class="oneMore" @click="toListCenter(columnData.column2)">
            <img :src="require('../assets/moreIconPro.png')" alt="" />
          </div>
        </div>
        <!-- 栏位1 -- 最新动态 -->
        <div class="oneDiv">
          <div class="oneContent">
            <div class="oneContentLeft" @click="toDetail(newsLeftData.id,newsLeftData.title)">
              <img
                :src="'/mainsys/UserFiles/menupic/' + newsLeftData.picUrl"
                v-if="newsLeftData.picUrl"
                style="width:100%;height:100%"
              />
              <img v-else src="@/assets/xinwen.png" alt=""  style="width:100%;height:100%">
              <div class="oneContentLeftContent">
                <div style="color:#FFFFFF;margin-bottom:8px">
                  {{ timeToYearMonthDay(newsLeftData.addDate) }}
                </div>
                <div
                  style="font-weight: 700;font-size: 18px;color: #FFFFFF;margin-bottom:14px"
                >
                  {{ newsLeftData.title }}
                </div>
                <el-divider></el-divider>
                <div
                  style="font-size: 12px;letter-spacing:1px;line-height:18px;color: #FFFFFF;margin-top:14px;  overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;"
                >{{newsLeftData.descripton}}</div>
              </div>
            </div>
            <div class="oneContentMiddle"></div>
            <div class="oneContentRight">
              <div class="oneContentPhoto">
                <img
                  :src="require('../assets/news.png')"
                  alt=""
                  style="height:200px;width:490px"
                />
              </div>
              <div
                v-for="(item, index) in newsRightData"
                :key="index"
                class="oneContentList"
                v-on:mouseenter="onMouseEnter(index, item)"
                @click="toDetail(item.id,item.title)"
              >
                <el-divider
                  direction="vertical"
                  class="oneContentbefore"
                ></el-divider>
                <div class="oneContentListChild">
                  <div style="color:#176DAA;margin-bottom:8px">
                    【 {{ timeToYearMonthDay(item.addDate) }} 】
                  </div>
                  <div class="oneContentTitle">
                    {{ item.title }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 栏位2和栏位3 -->
        <div class="twoToThreeDiv mt-10">
          <!-- 栏位2 -->
          <div class="twoDiv">
            <div class="twoMenu">
              <div
                v-for="(item, index) in columnData.column2.twoData"
                :key="index"
                @click="changeColumn(item, index)"
                class= 'flex items-center pl-6'
                :class="
                  chooseColumn2 == index ? 'twoMenuChildChoose' : 'twoMenuChild'
                "
              >
                {{ item.label }}
                <img
                  style="margin-left: 24px;margin-bottom: -1px;"
                  :src="require('../assets/choose.png')"
                  alt=""
                  v-if="chooseColumn2 == index"
                />
                <span v-else style="margin-left: 24px"></span>
              </div>
            </div>
            <div class="twoContent">
              <div
                v-for="(item, index) in column2Con"
                :key="index"
                class="twoContentList"
                @click="toDetail(item.id,item.title)"
              >
                <div class="twoContentImg">
                  <img
                    @error="handleImageError"
                    :src="item.picUrl ? '/mainsys/UserFiles/menupic/' + item.picUrl : require('../assets/2.png')"
                    style="height:100%;object-fit: cover; margin: 0 auto;"
                  />
                  <div class="twoContentDay">
                    <span
                      style="font-size: 28px;color: #FFFFFF;letter-spacing: 0;margin-bottom: -7px;margin-top: 2px;display: block;"
                    >
                      {{ timeToYearMonthDayThree(item.addDate).day }}
                    </span>
                    <span
                      style="font-size: 12px;color: #FFFFFF;letter-spacing: 0;"
                    >
                      {{ timeToYearMonthDayThree(item.addDate).year }}
                    </span>
                  </div>
                </div>
                <div class="twoContentDiv">
                  <div class="twoContentTitle">{{ item.title }}</div>
                  <div class="twoContentbefore"></div>
                  <div class="twoContentAfter"></div>
                  <div class="twoContents">{{item.descripton}}</div>
<!--                  <div class="twoContentbefore">-->
<!--                    <el-divider></el-divider>-->
<!--                  </div>-->
                </div>
              </div>
              <el-divider></el-divider>
              <div class="twoMore flex items-center gap-1" @click="toListCenter(columnData.column2)">
                <span style="margin:0 4px 0 8px"> 查看更多</span>
                <img
                  :src="require('../assets/moreIcon.png')"
                  alt=""
                  style="width:14px;height:8px"
                />
              </div>
            </div>
          </div>
          <!-- 栏位3 -->
          <div class="threeDiv  flex-1">
            <div class="threeTitleDiv">
              <div class="threeTitle">
                {{ columnData.column3.label }}
              </div>
              <div class="threeTitleBorder"></div>
            </div>
            <div class="threeContentDiv">
              <div
                class="threeContentList"
                v-for="(item, index) in columnData.column3.newData"
                :key="index"
                @click="toDetail(item.id,item.title)"
              >
                <div class="threeDayDiv">
                  <div style="width: 45px;height: 45px">
                    <div
                      style="font-size: 20px;color: #FFFFFF;letter-spacing: 0;"
                    >
                      {{ timeToYearMonthDayThree(item.addDate).day }}
                    </div>
                    <div
                      style="font-size: 12px;color: #FFFFFF;letter-spacing: 0;"
                    >
                      {{ timeToYearMonthDayThree(item.addDate).year }}
                    </div>
                  </div>
                </div>
                <div class="threeContentListChild">
                  <div class="threeContentTitle">
                    {{ item.title }}
                  </div>
                  <div class="threeContent">{{item.descripton}}</div>
                </div>
              </div>
              <div class="threeMore flex items-center" @click="toList(columnData.column3.id)">
                <span style="margin:0 4px 0 8px"> 查看更多</span>
                <img
                  :src="require('../assets/moreIconWhite.png')"
                  alt=""
                  style="width:14px;height:8px"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="fourBox">
        <div class="fourTitleDiv">
          <div class="oneTitle">
            <div class="pubTitle">
              <img :src="require('../assets/title1.png')" alt="" width="28px" height="28px"/>
              <span style="margin-left: 14px;">{{ columnData.column4.label }}</span>
            </div>
            <div class="pubTitles">
              <div style="width: 32px;height: 2px;background: #176DAA;margin-right: 10px"></div>
              {{ columnData.column4.englishName }}
            </div>
          </div>
          <div class="fourMore" @click="toList(columnData.column4.id)">
            <img :src="require('../assets/moreIconPro.png')" alt="" />
          </div>
        </div>
        <!-- 栏位4 -->
        <div class="fourDiv">
          <div class="fourContentList gap-6">
            <div
              class="fourContentChild"
              v-for="(item, index) in columnData.column4.newData"
              :key="index"
              @click="toDetail(item.id,item.title)"
            >
              <div class="fourContentImg">
                <img
                  @error="handleImageError"
                  :src="'/mainsys/UserFiles/menupic/' + item.picUrl"
                  style="height:268px;width: 100%;object-fit: cover;"
                />
              </div>
              <div class="fourContentDiv">
                <div class="fourContentTitle">
                  {{ item.title }}
                </div>
                <div class="fourContent">{{item.descripton}}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 栏位5和外部链接 -->
          <div class="fiveTitleDiv">
            <div class="oneTitle">
              <div class="pubTitle">
                <img :src="require('../assets/title1.png')" alt="" width="28px" height="28px"/>
                <span style="margin-left: 14px;">{{ columnData.column5.label }}</span>
              </div>
              <div class="pubTitles">
                <div style="width: 32px;height: 2px;background: #176DAA;margin-right: 10px"></div>
                {{ columnData.column5.englishName }}
              </div>
            </div>
            <div
              style="display:flex;align-items: center;justify-content: space-between;flex:1;margin-left:260px;margin-top: 10px"
            >
              <div style="display:flex;align-items: center;">
                <div
                  style="width: 1px;height: 54px;opacity: 0.8; background: #999999;margin-right:45px"
                ></div>
                <div
                  v-for="(item, index) in columnData.column5.twoData"
                  :key="index"
                  @click="changeColumn5(item, index)"
                  :class="
                    chooseColumn5 == index ? 'fiveChooseMenu' : 'fiveMenu'
                  "
                >
                  {{ item.label }}
                </div>
              </div>
              <div class="oneMore" @click="toListTeach(columnData.column5.id)">
                <img :src="require('../assets/moreIconPro.png')" alt="" />
              </div>
            </div>
          </div>
          <!-- 栏位5 -->
          <div class="fiveDiv">
            <div class="fiveContentList gap-6">
              <div
                class="fiveContentChild"
                v-for="(item, index) in column5Con"
                :key="index"
                @click="toDetail(item.id,item.title)"
              >
                <div class="fiveContentImg">
                  <img
                    @error="handleImageError"
                    :src="'/mainsys/UserFiles/menupic/' + item.picUrl"
                    style="width:100%;height:240px;object-fit: cover"
                  />
                </div>
                <div class="fiveContentDiv">
                  <div
                    :class="
                    item.descripton.includes('省级一流')
                      ? 'fiveContentTitless'
                      : 'fiveContentTitle'
                  "
                  >
                    <!-- <div
                      :class="
                        item.descripton.includes('省级一流')
                          ? 'fiveContentDess'
                          : 'fiveContentDes'
                      "
                    >
                      {{ item.descripton }}
                    </div> -->
                    <div class="fiveContentTitles">
                      {{ item.title }}
                    </div>
                  </div>
                  <div class="fiveContent">{{item.descripton}}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- 链接 -->
          <div class="linkOut">
            <div class="linkTitleDiv">
              <div class="linkTitle">
                <div class="pubLinkTitle">
                  资源平台
                </div>
                <div class="pubTitles">
                  —— Resource platform ——
                </div>
              </div>
            </div>
            <div class="fiveContentList1 gap-6">
              <div
                class="linkContentChild"
                v-for="(item, index) in friendshipLink.outer"
                :key="index"
                @click="goLink(item)"
              >
                <div style="height: 50px;width: 50px;margin-right:20px">
                  <img
                    @error="handleImageError"
                    :src="'/mainsys/UserFiles/externalicon/' + item.linkImage"
                    style="height: 50px;margin: 0 auto;"
                  />
                </div>
                <div>
                  <div class="fourContentTitle">
                    {{ item.linkName }}
                  </div>
                  <div class="linkContent">{{ item.linkDescription }}</div>
                </div>
              </div>
            </div>
          </div>
      </div>
      <!-- 底部快捷链接 -->
      <div class="bottomLink">
        <div style="
            margin: 0 auto;display: flex;
            align-items: center;
            justify-content: center;
            width: 1300px;
            padding: 0 5%;
            height: 60px;
">
          <div
            v-for="(item, index) in friendshipLink.res"
            :key="index"
            class="bottomLinkList"
            :style="{cursor:item.linkName == '中心服务'?'default':'pointer'}"
            @click="goLink(item)"
          >
            <div style="display:flex;align-items: center;">
              <img
                :src="'/mainsys/UserFiles/externalicon/' + item.linkImage"
                style="height: 18px;width: 18px;margin-right:12px;"
              />
              <div style="line-height: 20px;height: 20px;">
                {{ item.linkName }}
              </div>
            </div>
          </div>
        </div>

      </div>
      <!-- 底部版权信息 -->
      <div class="copyDiv">
        <div style="width: 100%;margin: 0 auto;display: flex;
          justify-content: space-between;
          align-items: center;">
          <div class="copyDivLeft">
            <img
              :src="require('../assets/bottomLogo.png')"
              alt=""
              style="width:360px;height:50px;margin-bottom:16px"
            />
            <div class="copyDivLeftCon">建设单位：国防科技大学</div>
            <div class="copyDivLeftCon">支持单位：湖南强智科技发展有限公司</div>
            <div class="copyDivLeftCon">
              推荐使用: Chrome或Firefox等主流浏览器
            </div>
            <div class="copyDivLeftCon">
              Copyright © 1999- 2024 国防科技大学 版权所有
            </div>
            <div class="copyDivLeftCon">
              总计访问次数：{{websiteVisitsNum}} 次 <span style="margin-left: 50px">年度访问次数：{{yearCount}} 次</span>
            </div>
          </div>
          <div
            class="copyDivRight"
            style="text-align:center;width: 140px"
            v-if="friendshipLink.top && friendshipLink.top.length > 0"
          >
            <img
              :src="
              '/mainsys/UserFiles/externalicon/' +
                friendshipLink.top[0].linkImage
            "
              alt=""
              style="width:140px;height:140px;margin:0 auto;text-align: center"
            />
            <div style="font-size: 16px;color: #FAFAFA;margin-top: 16px">
              {{ friendshipLink.top[0].linkName }}
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import Header from "@/views/Header.vue";
export default {
  data() {
    return {
      slideShowList: [], //轮播图的数组
      columnData: {
        column1: {},
        column2: {},
        column3: {},
        column4: {},
        column5: {}
      },
      loginStatus: 1, //1-未登录 2-已登录
      newsLeftData: {},
      newsRightData:[],
      chooseColumn2: 0,
      chooseColumn2Name:'',
      column2Con: [],
      chooseColumn5: 0,
      column5Con: [],
      websiteVisitsNum:0,
      yearCount:0,
      top:0,
      scaleFactor: 1, // 初始缩放比例
    };
  },
  components: {
    Header,
  },
  methods: {
    handleImageError(e){
      e.target.src = require('../assets/2.png')
    },
    handleResize() {
      const windowWidth = window.innerWidth;
      const baseWidth = 1920; // 基准宽度
      console.log(windowWidth / baseWidth);
      this.scaleFactor = windowWidth / baseWidth
    },
    onMouseEnter(index, item) {
      this.newsLeftData = item;
      console.log("Div is hovered!", index, item);
    },
    timeToYearMonthDay(time) {
      var newTime = new Date(time);
      var year = newTime.getFullYear();
      var month = newTime.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      var date = newTime.getDate();
      date = date < 10 ? "0" + date : date;
      return year + "年" + month + "月" + date + "日";
    },
    timeToYearMonthDayThree(time) {
      var newTime = new Date(time);
      var year = newTime.getFullYear();
      var month = newTime.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      var date = newTime.getDate();
      date = date < 10 ? "0" + date : date;
      let datas = {
        year: year + "." + month,
        day: date
      };
      return datas;
    },
    changeColumn(item, index) {
      console.log(item,'dsads')
      this.column2Con = item.data;
      this.chooseColumn2 = index;
      this.chooseColumn2Name = item.label
    },
    changeColumn5(item, index) {
      this.column5Con = item.data;
      this.chooseColumn5 = index;
    },
    toListCenter(item) {
      console.log(item,'iter')
      if(item.twoData&&item.twoData.length>0){
        this.$router.push({
          path: "List:menuId",
          name: "List",
          params: { menuId: item.twoData[0].id },
        });
      }

    },
    toListTeach(menuId) {
      let id =""
      if(this.columnData.column5.twoData && this.columnData.column5.twoData.length>0){
        id = this.columnData.column5.twoData[0].id
      }else{
        id = menuId
      }
      this.$router.push({
        path: "ListTeach:menuId",
        name: "ListTeach",
        params: { menuId: id },
      });
    },
    toList(menuId) {
      this.$router.push({
        path: "List:menuId",
        name: "List",
        params: { menuId: menuId }
      });
    },
    getSlideShow() {
      //获取轮播图
      axios.post("/cmsapi/getSlideshow").then(response => {
        let recData = response.data;
        this.slideShowList = recData;
        if (this.slideShowList.length > 0) {
          for (var i = 0; i < this.slideShowList.length; i++) {
            this.slideShowList[i].coverPic =
              "/mainsys/UserFiles/coverpic/" + this.slideShowList[i].coverPic;
          }
        } else {
          this.slideShowList = [
            {
              coverPic: require("../assets/list/banners.png")
            },
          ];
        }
      });
    },
    toDetail(contentId,title) {
      this.$router.push({
        name: "Detail",
        params: { contentId: contentId,label:title }
      });
    },
    toDetail1(contentId,item){
      console.log(item,'item轮播')
      if(item.coverUrl){
        window.open(item.coverUrl)
      }
      // if(item.description){
      //   localStorage.setItem('isRefresh','1')
      //   this.$router.push({
      //     name: "Detail",
      //     params: { contentId: contentId,label:item.title}
      //   });
      // }
    },
    goLink(item) {
      if(item.linkName=='头歌'){
        this.$router.push({
          path: "/touGe",
          query: {url: item.linkUrl,activeIndex:null }
        });
      }else{
        if (item.linkUrl != "/") {
          if (item.linkTarget == "_blank") {
            window.open(item.linkUrl);
          } else {
            window.location.href = item.linkUrl;
          }
        }
      }

    },
    dateData(property, bol) {
      return function(a, b) {
        var value1 = a[property];
        var value2 = b[property];
        if (bol) {
          // 升序
          return Date.parse(value1) - Date.parse(value2);
        } else {
          // 降序
          return Date.parse(value2) - Date.parse(value1);
        }
      };
    },
    getList() {
      axios
        .post("/cmsapi/getIndexNews", {})
        .then(response => {
          let result = response.data.rootData[0].oneData;
          if (result && result.length > 0) {
            result.forEach(item => {
              if (item.boxcode == "1") {
                this.columnData.column1 = item;
                if (item.newData && item.newData.length > 0) {
                  this.newsLeftData = item.newData[0];
                  item.newData =
                    item.newData.length > 3
                      ? item.newData.splice(0, 3)
                      : item.newData;
                }
              } else if (item.boxcode == "2") {
                this.columnData.column2 = item;
                if (item.twoData && item.twoData.length > 0) {
                  let data = [];
                  item.twoData.forEach(val => {
                    if (val.data && val.data.length > 0) {
                      val.data =
                        val.data.length > 4 ? val.data.splice(0, 4) : val.data;
                    }
                    if (val.data && val.data.length > 0) {
                      data.push(...val.data);
                    }
                  });
                  if (data.length > 0) {
                    data.sort(this.dateData("addDate", false));
                    this.newsLeftData = data[0];
                    this.newsRightData =
                      data.length > 3 ? data.splice(0, 3) : data;
                  }
                  this.column2Con = item.twoData[0].data;
                }
              } else if (item.boxcode == "3") {
                this.columnData.column3 = item;
                if (item.newData && item.newData.length > 0) {
                  item.newData =
                    item.newData.length > 4
                      ? item.newData.splice(0, 4)
                      : item.newData;
                }
              } else if (item.boxcode == "4") {
                this.columnData.column4 = item;
                if (item.newData && item.newData.length > 0) {
                  item.newData =
                    item.newData.length > 6
                      ? item.newData.splice(0, 6)
                      : item.newData;
                }
              } else if (item.boxcode == "5") {
                this.columnData.column5 = item;
                if (item.twoData && item.twoData.length > 0) {
                  item.twoData.forEach(val => {
                    if (val.data && val.data.length > 0) {
                      val.data =
                        val.data.length > 3 ? val.data.splice(0, 3) : val.data;
                    }
                  });
                  this.column5Con = item.twoData[0].data;
                }
              }
            });
          }
        })
        .catch(error => {
          console.log(error);
          // this.$message.error('网络出现问题，请检查网络！');
        });
    },
    getListNo() {
      axios
        .post("/cmsapi/getNotLogIn", {})
        .then(response => {
          let result = response.data.rootData[0].oneData;
          if (result && result.length > 0) {
            result.forEach(item => {
              if (item.boxcode == "1") {
                this.columnData.column1 = item;
                if (item.newData && item.newData.length > 0) {
                  this.newsLeftData = item.newData[0];
                  item.newData =
                    item.newData.length > 3
                      ? item.newData.splice(0, 3)
                      : item.newData;
                }
              } else if (item.boxcode == "2") {
                this.columnData.column2 = item;
                if (item.twoData && item.twoData.length > 0) {
                  let data = [];
                  item.twoData.forEach(val => {
                    if (val.data && val.data.length > 0) {
                      val.data =
                        val.data.length > 4 ? val.data.splice(0, 4) : val.data;
                    }
                    if (val.data && val.data.length > 0) {
                      data.push(...val.data);
                    }
                  });
                  if (data.length > 0) {
                    data.sort(this.dateData("addDate", false));
                    this.newsLeftData = data[0];
                    this.newsRightData =
                      data.length > 3 ? data.splice(0, 3) : data;
                  }
                  this.column2Con = item.twoData[0].data;
                }
              } else if (item.boxcode == "3") {
                this.columnData.column3 = item;
                if (item.newData && item.newData.length > 0) {
                  item.newData =
                    item.newData.length > 4
                      ? item.newData.splice(0, 4)
                      : item.newData;
                }
              } else if (item.boxcode == "4") {
                this.columnData.column4 = item;
                if (item.newData && item.newData.length > 0) {
                  item.newData =
                    item.newData.length > 6
                      ? item.newData.splice(0, 6)
                      : item.newData;
                }
              } else if (item.boxcode == "5") {
                this.columnData.column5 = item;
                if (item.twoData && item.twoData.length > 0) {
                  item.twoData.forEach(val => {
                    if (val.data && val.data.length > 0) {
                      val.data =
                        val.data.length > 3 ? val.data.splice(0, 3) : val.data;
                    }
                  });
                  this.column5Con = item.twoData[0].data;
                }
              }
            });
          }
          console.log("this.columnData", this.columnData);
        })
        .catch(error => {
          console.log(error);
          // this.$message.error('网络出现问题，请检查网络！');
        });
    },
    getAccessLogNum(){
     axios
      .post("/cmsapi/getAccessLogNum").then((res)=>{
        if(res.data.code == '2'){
          this.websiteVisitsNum = res.data.data
          this.yearCount=res.data.yearCount
        }
      })
    },

  },
  created() {
    console.log('friendshipLink', this.friendshipLink)
    //获取当前用户登录状态
    axios
      .post("/getUserLoginInfo")
      .then(response => {
        let data = response.data; //数据
        if (data.code > 0) {
          this.loginStatus = data.code;
          sessionStorage.setItem("loginStatus", data.code);
          if (data.data) {
            sessionStorage.setItem("schType", data.data.schType);
            sessionStorage.setItem("userId", data.data.userId);
            if (data.code == 2) this.userInfo = data.data;
          }
          this.getList();
          // console.log(this.loginStatus, "this.loginStatus");
          // if (this.loginStatus == "2") {
          //   this.getList();
          // } else {
          //   console.log(2222222222222);
          //   this.getListNo();
          // }
        }
      })
      .catch(error => {
        console.error(error);
      });

    this.getSlideShow();
    this.getAccessLogNum()
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize(); // 初始化时执行一次
  },
  beforeDestroy() {
    // 在组件销毁前清除定时器，以防止内存泄漏
    clearTimeout(this.timer);
  }
};
</script>

<style scoped >
.mainContent {
  /* height: calc(100% - 122px);
  width: 100%; */
  transform-origin: center;
  /* 确保子元素也按比例缩放 */
  width: calc(100% / var(--scale-factor));
  height: calc(100% / var(--scale-factor));
  transform: scale(var(--scale-factor));
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(var(--scale-factor));
}
.mainContent >>> .el-carousel__indicators--horizontal {
  bottom: 15px !important;
  left: 20% !important;
}
.centerDiv {
  position: relative;
  /* padding: 0 260px;
  width: calc(100% - 520px); */
  width: 100%;
  height: auto;
}
.backgroundImgDiv{
  position: absolute;
  width: 100%;
  background-size: 100% auto;
  background: url("../assets/bg1.png") no-repeat center;
  z-index: -99;
  height: 650px;
  top: 275px;
}
.oneToThree {
  height: 1340px;
  /* min-height: 1000px; */
  width: 100%;
  margin: 0 auto;
}
.fourBox{
  width: 100%;
  margin: 0 auto;
  position: relative;
}
.oneDiv {
  height: 426px;
  padding:0 160px;
  z-index: 999;
  /* width: calc(100% - 520px); */
  /* background-color: red; */
  /* border-bottom: 2px solid red; */
}
.oneTitleDiv {
  height: 70px;
  width: calc(100% - 278px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin:30px 160px 24px 118px;
}
.oneTitle {
  height: 100%;
  width: 217px;
  background: url("../assets/title.png") no-repeat;
  position: absolute;
  left: -16px;
}
.pubTitle {
  font-family: MicrosoftYaHei-Bold;
  font-weight: 700;
  font-size: 26px;
  color: #176DAA;
  letter-spacing: 3.29px;
  display: flex;
  align-items: center;
  margin-top: 15px;
  margin-left: 14px;
}
.pubTitles {
  color: #176daa;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  text-align: left;
  margin-left: 14px;
  display: flex;
  align-items: center;
  margin-top: -4px;
}
.oneMore {
  cursor: pointer;
  position: absolute;
  right: 0;
  bottom:0;
  height: 34px;
  width: 134px;
}
.fourMore {
  cursor: pointer;
  position: absolute;
  right: 0;
  bottom:8px;
  height: 34px;
  width: 134px;
}

.oneContent {
  width: 100%;
  height: 426px;
  /* background-color: red; */
  display: flex;
}
.oneContentLeft {
  height: 422px;
  width: 1050px;
  position: relative;
  cursor: pointer;
  /* background: url("../assets/news.png") no-repeat;
  background-size: 100% 100%; */
  /* background-size: contain; */
}
.oneContentLeftContent {
  height: 153px;
  position: absolute;
  width:100%;
  /* background-color: red; */
  left: 0;
  bottom: 0;
  padding: 16px 32px;
  /* backdrop-filter: blur(2px); */
  background-color:rgba(14, 13, 13, 0.3);
}
.oneContentMiddle {
  height: 100%;
  width: 1px;
  background-color: #d5d5d5;
  margin-left: 30px;
}
.oneContentRight {
  height: 100%;
  flex: 1;
}
.oneContentPhoto {
 margin-left: 30px;
  width: 490px;
  height: 200px;
}
.oneContentList {
  height: 75px;
  width: 490px;
  cursor: pointer;
  display: block;
  position: relative;
}
.oneContentList:hover .oneContentbefore {
  display: block;
}

.oneContentListChild {
  width: 100%;
  height: 75px;
  padding: 12px 0 12px 0px;
  margin-left: 30px;
  border-bottom: 1px dashed #dbdbdb;
}
.oneContentTitle {
  font-size: 16px;
  white-space: nowrap;overflow: hidden;text-overflow: ellipsis;
  width: 100%;
}
.oneContentTitle:hover {
  color: #176DAA;
}
.oneContentbefore {
  position: absolute;
  display: none;
}
.el-divider--vertical {
  margin: 0px !important;
  background-color: #176DAA !important;
  height: 60px !important;
  width: 8px !important;
  top: 8px !important;
  left: -4px;
}
.el-divider--horizontal {
  margin: 0px !important;
  background-color: #d6d6d6 !important;
  opacity: 0.5;
}
.twoToThreeDiv {
  height: 777px;
  padding: 0 160px;
  z-index: 999;
  /* width: calc(100% - 520px); */
  /* background-color: red; */
  display: flex;
  /* border-bottom: 2px solid red; */
}
.twoDiv {
  height: auto;
  width:1006px;
  /* background: red; */
}
.threeDiv {
  width: 520px;
  height: 777px;
  margin-left: 60px;
  background: #176DAA;
}
.threeTitleDiv {
  height: 91px;
  line-height: 91px;
  width: 100%;
  background: url("../assets/titleThrees.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
}
.threeTitle {
  font-weight: 700;
  font-size: 28px;
  color: #ffffff;
  letter-spacing: 0;
  margin-left: 30px;
}
.threeTitleBorder {
  height: 2px;
  width: 108px;
  background-color: #ffffff;
  position: absolute;
  bottom: 0px;
  left: 30px;
}
.threeContentDiv {
  height: 680px;
  width: 100%;
  position: relative;
}
.threeContentList {
  /* width: calc(100% - 60px); */
  width: 100%;
  position: relative;
  padding: 20px 30px 20px 30px;
  height: 160px;
  display: flex;
  cursor: pointer;
  /* background-color: aquamarine; */
}
.threeContentList:hover {
  background-color: #2F7CB3;
}
.threeContentList:hover:before {
  position: absolute;
  left: 0px;
  top: 0px;
  height: 160px;
  width: 8px;
  content: "";
  /* -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5); */
  background-color: #D4DC8C;
}
.threeContentList:after {
  position: absolute;
  bottom: 0;
  left: 106px;
  right: 0px;
  height: 1px;
  content: "";
  /* -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5); */
  background-color: #fff;
  opacity: 0.2;
}
.threeDayDiv {
  height: 52px;
  width: 54px;
  margin-right: 20px;
  text-align: center;
  background: url("../assets/dayBg.png") no-repeat;
  background-size: 100% 100%;
}
.threeContentListChild {
  width: 380px;
  /* flex: 1; */
  /* width: calc(100% - 75px); */
}
.threeContentTitle {
  font-weight: 700;
  font-size: 18px;
  color: #ffffff;
  letter-spacing: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  margin-bottom: 8px;
}
.threeContent {
  opacity: 0.6;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  line-height: 22px;
}
.threeMore {
  font-size: 16px;
  color: #ffffff;
  position: absolute;
  bottom: 6px;
  right: 28px;
  cursor: pointer;
}
.twoMore {
  font-size: 16px;
  color: #176DAA;
  position: absolute;
  bottom: 10px;
  right: 0px;
  cursor: pointer;
}
.twoMenu {
  width: 145px;
  height: auto;
  background-color: #fff;
  border-left: 4px solid #176DAA;
  float: left;
  margin-right: 64px;
}
.twoMenuChild {
  height: 58px;
  width: 140px;
  line-height: 58px;
  text-align: center;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  cursor: pointer;
  /* padding-right: 24px; */
}
.twoMenuChild:hover {
  height: 58px;
  line-height: 58px;
  text-align: center;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  background: #176DAA;
  width: 145px;
  cursor: pointer;
}
.twoMenuChildChoose {
  height: 58px;
  line-height: 58px;
  text-align: center;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  background: #176DAA;
  width: 160px;
  cursor: pointer;
}
.twoContent {
  width: calc(100% - 212px);
  /* width: 793px; */
  height: 100%;
  /* background-color: red; */
  float: left;
  position: relative;
}
.twoContentList {
  /* border-bottom: 1px solid red; */
  height: 150px;
  width: 100%;
  display: flex;
  margin-bottom: 32px;
}
.twoContentImg {
  height: 150px;
  width:263px;
  position: relative;
}
.twoContentDay {
  position: absolute;
  left: -17px;
  bottom: 17px;
  width: 62px;
  height: 62px;
  background: #d3b17d;
  text-align: center;
}
.twoContentDiv {
  height: 150px;
  width: calc(100% - 263px);
  /* background-color: red; */
  padding-left: 30px;
  padding-top: 10px;
  /* width: 100%; */
  position: relative;
  cursor: pointer;
}
.twoContentDiv:hover .twoContentTitle {
  color: #176DAA;
}
.twoContentDiv:hover .twoContentbefore {
  display: block;
}
.twoContentDiv:hover .twoContentAfter {
  display: none;
}
.twoContentAfter{
  width: 245px;height: 6px;background-color: #0C72B5;margin: 4px 0;
}
.twoContentbefore {
  width: 500px;
  height: 6px;
  background-image: linear-gradient(270deg, #CED589 0%, #3A7CB5 54%, #FFFFFF 87%, #FFFFFF 100%);
  margin: 4px 0;
  display: none;
}
.twoContentTitle {
  font-weight: 700;
  font-size: 18px;
  color: #333333;
  letter-spacing: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.twoContents {
  opacity: 0.6;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  line-height: 24px;
}
.fourDiv {
  height: 845px;
  padding: 0 160px;
  /* width: calc(100% - 520px); */
  /* background: url("../assets/bg2.png") no-repeat;
  background-size: 100% 100%; */
}
.fourBgImg{
  position: absolute;
  width: 100%;
  background-size: 100% auto;
  background: url("../assets/bg2s.png") no-repeat center;
  z-index: -99;
  height: 989px;
  top: 1290px;
}
.fourTitleDiv {
  height: 70px;
  width: calc(100% - 278px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin:0px 160px 24px 118px;
}
.fourContentList {
  width: 100%;
  /* height: calc(100% - 110px); */
  display: flex;
  flex-wrap: wrap;
  /* gap: 30px; */
}
.fourContentChild {
  height: 382px;
  /* width: 435px; */
  width: 508px;
  /* margin-right: 37px; */
  /* border: 1px solid #176DAA; */
  background: #fff;
  cursor: pointer;
  box-sizing: border-box;
  box-shadow: 0 6px 12px 0 #0000001f;
}
.fourContentChild:hover {
  border-bottom: 8px solid #176DAA;
}
.fourContentImg {
  height: 268px;
  width: 100%;
}
.fourContentDiv {
  padding: 18px 20px;
}
.fourContentTitle {
  font-weight: 700;
  font-size: 18px;
  color: #333333;
  letter-spacing: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  margin-top: -5px;
  margin-bottom: 5px;
}
.fourContent {
  opacity: 0.6;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-height: 22px;
}
.fourContentChild:hover .fourContentTitle {
  color: #176DAA;
}
.fiveBgImg{
  position: absolute;
  width: 100%;
  background-size: 100% auto;
  background: url("../assets/bg3s.png") no-repeat bottom;
  z-index: -99;
  height: 920px;
  top: 2280px;
}
.fiveToLink {
  padding: 0 160px;
  width: 100%;
}
.fiveDiv {
  height: 378px;
  padding: 0 160px;
  width: 100%;
}
.fiveTitleDiv {
  height: 70px;
  width: calc(100% - 278px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin:30px 160px 24px 118px;
}
.fiveContentList {
  width: 100%;
  /* height: calc(100% - 110px); */
  display: flex;
  flex-wrap: wrap;
  /* gap: 30px; */
}
.fiveContentList1 {
  width: 100%;
  /* height: calc(100% - 110px); */
  display: flex;
  flex-wrap: wrap;
  /* gap: 30px; */
}
.fiveContentChild {
  height: 376px;
  /* width: 435px; */
  width: 508px;
  background: #fff;
  cursor: pointer;
  box-sizing: border-box;
}
.fiveContentChild:nth-child(3n+1){
  margin-left: 0;
}

.fiveContentImg {
  height: 240px;
  width: 100%;
}
.fiveContentTitle {
  margin-bottom: 12px;
  border-left: 2px solid #176DAA;
}
.fiveContentTitless {
  margin-bottom: 12px;
  border-left: 2px solid #bb7915;
}
.fiveContentDes {
  margin-left: 20px;
  font-size: 12px;
  margin-bottom: 8px;
  color: #176DAA;
  height: 20px;
  width: 100%;
  white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
}
.fiveContentDess {
  margin-left: 20px;
  font-size: 12px;
  margin-bottom: 8px;
  color: #bb7915;
    height: 20px;
  width: 100%;
  white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
}
.fiveContentTitles {
  font-weight: 700;
  margin-left: 20px;
  font-size: 18px;
  color: #333333;
  letter-spacing: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.fiveContent {
  font-size: 16px;
  margin-left: 20px;
  color: #666666;
  letter-spacing: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-height: 30px;
}
.fiveContentDiv {
  padding: 24px 30px;
  /* width: calc(100% - 61px); */
  border-bottom: 1px solid #e5e5e5;
  border-left: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
  height: 136px;
}
/* .fiveContentChild:hover .fiveContentDiv {
  background-color:#176DAA;
} */
.fiveContentDiv:hover {
  background: url("../assets/teachs.png") no-repeat;
  background-size: 174px 80px;
  background-position: bottom right;
  z-index: 999999;
  background-color: #176DAA;
  border:0px solid #176DAA;
}
.fiveContentDiv:hover .fiveContent {
  opacity: 0.8;
  color: #fff;
}
.fiveContentDiv:hover .fiveContentTitles {
  color: #fff;
}
.fiveContentDiv:hover .fiveContentDes {
  color: #fff;
}
.fiveContentDiv:hover .fiveContentDess {
  color: #fff;
}
.fiveContentDiv:hover .fiveContentTitle {
  border-left: 2px solid #fff;
}
.fiveContentDiv:hover .fiveContentTitless {
  border-left: 2px solid #fff;
}
.fiveMenu {
  font-size: 16px;
  color: #666666;
  letter-spacing: 0;
  padding: 8px 0;
  cursor: pointer;
  margin-right: 45px;
}
.fiveChooseMenu {
  font-weight: 700;
  font-size: 18px;
  color: #176DAA;
  letter-spacing: 0;
  padding: 8px 0;
  border-bottom: 2px solid #176DAA;
  cursor: pointer;
  margin-right: 45px;
}
.fiveMenu:hover {
  color: #176DAA;
  font-weight: 700;
  font-size: 18px;
  border-bottom: 2px solid #176DAA;
}
.linkOut {
  height: 390px;
  padding: 0 160px;
  width: 100%;
  /* background: red; */
}
.linkTitleDiv {
  height: 70px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin:30px 0
}
.linkTitle {
  height: 100%;
  text-align: center;
  /* width: 217px; */
  padding-top: 16px;
  background: url("../assets/title.png") no-repeat;
  background-position: center;
}
.pubLinkTitle {
  font-weight: 700;
  font-size: 26px;
  color: #176DAA;
  letter-spacing: 4px;
  text-align: center;
}
.linkContentChild {
  height: 100px;
  /* width: 315px; */
  width:508px;
  background: #fff;
  cursor: pointer;
  box-sizing: border-box;
  padding:25px 20px;
  display: flex;border: 1px solid #E5E5E5;
}
.linkContent {
  opacity: 0.6;
  font-size: 16px;
  color: #666666;
  letter-spacing: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.linkContentChild:hover {
  border: 0px solid #E5E5E5;
  box-shadow: 0 4px 12px 0 #0000001f;
  border-bottom: 8px solid #176DAA;
}
.bottomLink {
  height: 60px;
  width: 100%;
  /* width: calc(100% - 520px); */
  background: #105C93;
  color: #fff;

  /* display: flex;
  align-items: center;
  justify-content: center; */
}
.bottomLinkList {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 280px;
  position: relative;
  }
.bottomLinkList:not(:last-child)::after {
  content: "";
  width: 1px;
  height: 24px;
  opacity: 0.2;
  background-color: #fff;
  position: absolute;
  right: 0;
}
.linkDivider >>> .el-divider--vertical {
  height: 24px !important;
  background-color: #3f6bae !important;
  width: 1.5px !important;
  margin: 0 30px 36px 30px !important;
}
.copyDiv {
  height: 300px;
  /* width: calc(100% - 520px); */
  padding: 40px 260px;
  background: url("../assets/bottomBgs.png") no-repeat;
  background-size: 100% 100%;

}
.copyDivLeftCon {
  opacity: 0.8;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0;
  margin-top: 12px;
}
.el-carousel__item {
  /* background-color: #99a9bf; */
  background: url("../assets/lbbanner.jpg") no-repeat !important;
  background-size: 100% 100% !important;
  /* z-index: 999; */
}
</style>
